import React from "react";
import { BaseComponent } from "..";
import DataList from "../DataList";
import CustomTableExpand from "../CustomTableExpand";
import CustomSelect from "../Macros/CustomSelect";

const columns = [
  {
    title: "שם מעסיק" ,
    dataIndex: "employerName",
    width: 300,

  },
  {
    title: "חודש משכורת",
    dataIndex: "salaryMonth",
    width: 200,
  },
  {
    title: "מועד הפקדה",
    dataIndex: "depositDate",
    width: 200,
  },
  { title: "התאמה", dataIndex: "match", width: 100 },
  ,
  {
    title: "",
    dataIndex: "action",
    minWidth: 200,
  },
];

export default class PaymentClassification extends BaseComponent {
  
  constructor(props) {
    super(props);
    let years = this.siteSetting("tax_years_list").split(",");

    years.unshift("שנה");
    this.state = {
      details: null,
      isLoading: true,
      pageNo: this.props.pageNo || 1,
      selectedYear: "",
      isResetForm: false,
      years: years.map(
        (x, i) =>
          ({
            label: x.toString(),
            value: i === 0 ? "" : x.toString(),
          } )
      ),
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.accountId !== this.props.accountId ||
      prevState.pageNo !== this.state.pageNo && !this.state.isResetForm
    ) {
      this.props.onPagination(this.state.pageNo, this.state.selectedYear);
    }
  }

  resetForm(event) {
    this.setState({ selectedYear: "", pageNo: 1, isResetForm: true }, () => {
      this.props.onPagination();
      this.setState({ isResetForm: false });
    });

    event.preventDefault();
  }

  submitForm(event) {
    this.setState({ pageNo: 1 }, this.props.onPagination(this.state.pageNo, this.state.selectedYear));

    event.preventDefault();
  }

  getOptions() {
    var syb = this.siteSetting('lastyeartoshowtaxreports')
    var maxRevaluationDate = parseInt(sessionStorage.getItem("maxRevaluationDate"));
    var years = new Array();
    years.unshift("שנה");
    const bottom = parseInt(syb);
    for (let year = maxRevaluationDate; year >= bottom; year--) {
      years.push(year);
    }

    return years.map(
      (x, i) =>
      ({
        label: x.toString(),
        value: i === 0 ? "" : x.toString(),
      })
    )

  }

  getDataList(record) {
    const dataList = [
      {
        title: "דיווח מעסיק",
        items: [
          {
            label: "תגמולי עובד",
            value: `${record.employeeAmount || 0} ₪`,
          },
          {
            label: "תגמולי מעסיק",
            value: `${record.employerAmount || 0} ₪`,
          },
          {
            label: "פיצויים",
            value: `${record.depositCompensationAmount || 0} ₪`,
          },
          {
            label: "שונות",
            value: record.miscellaneousAmount || 0,
          },
        ],
      },
      {
        title: "נקלט בפועל",
        items: [
          {
            label: "תגמולי עובד",
            value: `${record.depositEmployeeAmount || 0} ₪`,
          },
          {
            label: "תגמולי מעסיק",
            value: `${record.depositEmployerAmount || 0} ₪`,
          },
          {
            label: "פיצויים",
            value: `${record.depositCompensationAmount || 0} ₪`,
          },
          {
            label: "שונות",
            value: record.miscellaneousAmount || 0,
          },
        ],
      },
    ];
    return dataList;
  }

  render() {
    return (
      <div className="pane-content pane-content--deposit-details">
         <div className="filter-block-wrapper">
                    <div className="filter-block">
                      <h3 className="filter-block__heading">סנן לפי</h3>

                      <button
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseFilter"
                        aria-expanded="false"
                        aria-controls="collapseFilter"
                        aria-label="toggle controls"
                        className="filter-block__toggle collapsed"
                      >
                        <span className="caption">סנן לפי</span>
                      </button>

                      <div
                        id="collapseFilter"
                        className="collapse filter-block__collapse show"
                      >
                        <form
                          id="tax-reports-filter-form"
                          className="data-filter filter-block__form"
                        >
                          <div className="data-filter__row">
                            <div className="data-filter__inputs">
                              <div className="data-filter__inputs-row">
                                <div className="col-auto data-filter__col">
                                  <label htmlFor="df-date" className="sr-only">
                                    חודש משכורת
                                  </label>
                                  <CustomSelect
                                    id="df-date"
                                    buttonClassName="data-filter__input"
                                    options={this.getOptions()}
                                    value={this.state.selectedYear}
                                    onChange={(value) => {
                                      this.setState({ selectedYear: value });
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="data-filter__buttons">
                              <div className="data-filter__buttons-row">
                                <div className="col-auto data-filter__buttons-col">
                                  <button
                                    type="button"
                                    className="data-filter__btn data-filter__btn--reset"
                                    onClick={this.resetForm.bind(this)}
                                  >
                                    נקה
                                  </button>
                                </div>
                                <div className="col-auto data-filter__buttons-col">
                                  <button
                                    type="button"
                                    className="data-filter__btn"
                                    onClick={this.submitForm.bind(this)}
                                  >
                                    הצג
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
        {this.props.isLoading ? (
          <div style={{ textAlign: "center" }}>
            <img
              src="/img/loading.gif"
              alt="loading"
              style={{ height: "50px" }}
            />
          </div>
        ) : (
          this.props.data && (
            <>
              <CustomTableExpand
                columns={columns}
                data={this.props.data}
                totalPages={this.props.totalPages}
                totalCount={this.props.data.length}
                isTableLoading={this.props.isLoading}
                btnTxt="פרטים"
                isExpande
                expandedIdx={4}
                isHideTableTop={false}
                isHideExport={false}
                expandButtonText="פרטים"
                expandedRowRender={(record) => (
                  <DataList dataList={this.getDataList(record)} />
                )}
                onPagination={(page) => {
                  this.setState({ pageNo: page });
                }}
                onExportExcel={() => {
                  this.props.onExportExcel(this.state.selectedYear)
                }}
                isLoadingExcel={this.props.isLoadingExcel}
                currentPage={this.state.pageNo}
              />
            </>
          )
        )}
      </div>
    );
  }
}
